import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/auth.slice";
import { authApi } from "../api/auth.api";
import { chatApi } from "../api/chat.api";
import chatReducer from "../slices/chat.slice";
import { api } from "../api/api";
import adminReducer from "../slices/admin.slice";
import exercisesReducer from "../slices/exercises.slice";
import paymentSessionReducer from "../slices/paymentSession.slice";
import tutorialReducer from "../slices/tutorial.slice";
import entitlementsReducer from "../slices/entitlements.slice";
import accessControlReducer from "../slices/accessControl.slice";
import callCenterReducer from "../slices/callCenter.slice";

export const rootReducer = combineReducers({
  user: userReducer,
  [authApi.reducerPath]: authApi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  admin: adminReducer,
  chat: chatReducer,
  exercises: exercisesReducer,
  paymentSession: paymentSessionReducer,
  tutorial: tutorialReducer,
  callCenter: callCenterReducer,
  entitlements: entitlementsReducer,
  accessControl: accessControlReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      api.middleware,
      authApi.middleware,
      chatApi.middleware,
    ]),
  devTools: process.env.NODE_ENV === "development",
  preloadedState: undefined,
});

export type AppDispatch = typeof store.dispatch;
export default store;
